// extracted by mini-css-extract-plugin
export default {"TabsNav":"SettingsPage_TabsNav__2jB3j"};